import styled from '@emotion/styled';

export const FilterList = styled.div`
  padding: 0 ${props => props.theme.SPACING.MD};
  overflow: auto;
  flex: 1 1 max-content;
`;
